import type { MapStyleEnum } from '@cw-elements/map';
import type { CarbonLayerOption } from '../../core/models/metadata';
import type { ColorsEntity } from '../../core/models/user';
import type { MapMode, ViewMode } from './models';

const actions = {
  SET_MAP_MODE: '[Map] Set Map Mode',
  SET_LABEL_VISIBILITY: '[Map] Set Label Visibility',
  SET_ROAD_NAMES_VISIBILITY: '[Map] Set Road Names Visibility',
  SET_MAP_ZOOM: '[Map] Set Map Zoom',
  SET_FIELD_VARIABILITY: '[Map] Set Map Variability',
  SET_MAP_PALETTE_VARIABILITY: '[Map] Set Variability Palette',
  SET_MAP_PALETTE_PRESCRIPTIONS: '[Map] Set Prescription Palette',
  SET_MAP_VIEW_MODE: '[Map] Set Map View Mode',
  SET_MAP_STYLE: '[Map] Set Map Style',
  SET_SIDE_MAP_INDEX: '[Map] Set Side Map Index',
  SET_SIDE_MAP_ENABLED: '[Map] Side Map Enabled',
  SET_VARIABILITY_HINT: '[Image Assets] Set variability hint visible',
  SET_HOVERED_FIELD_ID: '[Map] Set Hovered Field Id',
  SET_MAP_SELECTED_CARBON_LAYER: '[Map] Set Selected Carbon Layer',
  SET_VISUAL_LAYER_VISIBILITY: '[Map] Set Visual Layer Visibility',
  SET_MAP_ANOMALY_DETECTION: '[Map] Set Anomaly Detection enabled on map',
  SET_TRIALING_PLOTS: '[Map] Set Trialing Plots enabled',
  setMapMode: (mode: MapMode) => ({
    type: actions.SET_MAP_MODE,
    payload: mode,
  }),
  setLabelVisibility: (visible: boolean) => ({
    type: actions.SET_LABEL_VISIBILITY,
    payload: visible,
  }),
  setRoadNamesVisibility: (visible: boolean) => ({
    type: actions.SET_ROAD_NAMES_VISIBILITY,
    payload: visible,
  }),
  setMapZoom: (zoom: number) => ({
    type: actions.SET_MAP_ZOOM,
    payload: zoom,
  }),
  setMapViewMode: (mode: ViewMode, map: string = 'map') => ({
    type: actions.SET_MAP_VIEW_MODE,
    map,
    payload: mode,
  }),
  setMapVariability: (value: number, map: string = 'map') => ({
    type: actions.SET_FIELD_VARIABILITY,
    map,
    payload: value,
  }),
  setMapPaletteVariability: (palette: ColorsEntity[], map: string = 'map') => ({
    type: actions.SET_MAP_PALETTE_VARIABILITY,
    map,
    payload: palette,
  }),
  setMapSelectedCarbonLayer: (selectedCarbonLayer: CarbonLayerOption, map: string = 'map') => ({
    type: actions.SET_MAP_SELECTED_CARBON_LAYER,
    map,
    payload: selectedCarbonLayer,
  }),
  setMapPalettePrescription: (
    palette: ColorsEntity[],
    paletteName: string | null,
    map: string = 'map'
  ) => ({
    type: actions.SET_MAP_PALETTE_PRESCRIPTIONS,
    map,
    payload: { palette, paletteName },
  }),
  setMapStyle: (style: MapStyleEnum) => ({
    type: actions.SET_MAP_STYLE,
    payload: style,
  }),
  setSideMapIndex: (index: string) => ({
    type: actions.SET_SIDE_MAP_INDEX,
    payload: index,
  }),
  setSideMapEnabled: (status: boolean) => ({
    type: actions.SET_SIDE_MAP_ENABLED,
    payload: status,
  }),
  setVariabilityHint: (value: boolean) => ({
    type: actions.SET_VARIABILITY_HINT,
    payload: value,
  }),
  setHoveredFieldId: (value: string | undefined) => ({
    type: actions.SET_HOVERED_FIELD_ID,
    payload: value,
  }),
  SET_MAPVIEW_SNAPSHOT_VISIBILITY: '[Map] Set Mapview Snapshot Visibility',
  setMapviewSnapshotVisibility: (value: boolean) => ({
    type: actions.SET_MAPVIEW_SNAPSHOT_VISIBILITY,
    payload: value,
  }),
  SET_MAPVIEW_SNAPSHOT_SETTINGS_VISIBILITY: '[Map] Set Mapview Snapshot Settings Visibility',
  setMapviewSnapshotSettingsVisibility: (value: boolean) => ({
    type: actions.SET_MAPVIEW_SNAPSHOT_SETTINGS_VISIBILITY,
    payload: value,
  }),
  setVisualLayerVisibility: (visible: boolean) => ({
    type: actions.SET_VISUAL_LAYER_VISIBILITY,
    payload: visible,
  }),
  setAnomalyDetectionMap: (state: boolean, map: string = 'map') => ({
    type: actions.SET_MAP_ANOMALY_DETECTION,
    map,
    payload: state,
  }),
  setTrialingPlotsEnabled: (state: boolean, map: string = 'map') => ({
    type: actions.SET_TRIALING_PLOTS,
    map,
    payload: state,
  }),
};

export default actions;
